import { CodeHighlight } from "@mantine/code-highlight";
import { Badge, Code, Group, Stack, Text, Title } from "@mantine/core";
import { type FragmentOf, graphql, readFragment } from "gql.tada";

import { JournalErrorAlert } from "./JournalErrorAlert";

export const RuleEngineGenerationScriptRanFragment = graphql(`
  fragment RuleEngineGenerationScriptRanFields on RuleEngineGenerationScriptRanPayload {
    __typename
    stepId
    script
    engineTiming {
      conditionEvalMs
      actionExecMs
      totalMs
    }
    printOutput
    printOutputTruncated
    error {
      code
      message
      hint
      stackHint
    }
  }
`);

interface Props {
  data: FragmentOf<typeof RuleEngineGenerationScriptRanFragment>;
}

export function RuleEngineGenerationScriptRanPayload({ data }: Props) {
  const p = readFragment(RuleEngineGenerationScriptRanFragment, data);
  return (
    <Stack gap="xs">
      <Group gap="xs" wrap="wrap">
        <Badge color="lime" size="xs">
          GENERATION SCRIPT
        </Badge>
        <Title order={6}>step {p.stepId.slice(0, 8)}</Title>
      </Group>
      <Stack gap={2}>
        <Text size="xs" fw={500}>
          Script
        </Text>
        <CodeHighlight code={p.script} language="lua" />
      </Stack>
      <Text size="xs" c="dimmed">
        timing: total {p.engineTiming.totalMs.toFixed(2)}ms
      </Text>
      {p.printOutput.length > 0 && (
        <Stack gap={2}>
          <Text size="xs" fw={500}>
            print output{p.printOutputTruncated ? " (truncated)" : ""}
          </Text>
          <Code block>{p.printOutput.join("\n")}</Code>
        </Stack>
      )}
      {p.error && <JournalErrorAlert error={p.error} />}
    </Stack>
  );
}
